import { useRef } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import VideoCard from "./VideoCard";

export default function VideoRow({ title, eyebrow, videos, testId }) {
  const ref = useRef(null);

  const scrollBy = (dir) => {
    const el = ref.current;
    if (!el) return;
    el.scrollBy({ left: dir * (el.clientWidth * 0.8), behavior: "smooth" });
  };

  return (
    <section className="relative" data-testid={testId || "video-row"}>
      <div className="flex items-end justify-between gap-6 mb-2">
        <div>
          {eyebrow && <p className="yv-eyebrow mb-1">{eyebrow}</p>}
          <h2 className="yv-h2 text-white">{title}</h2>
        </div>
        <div className="hidden md:flex gap-2">
          <button
            onClick={() => scrollBy(-1)}
            className="p-2 bg-white/5 hover:bg-[var(--yellow)] hover:text-black text-white rounded-full transition"
            aria-label="Scroll left"
            data-testid={`${testId || "row"}-prev`}
          >
            <ChevronLeft size={20} />
          </button>
          <button
            onClick={() => scrollBy(1)}
            className="p-2 bg-white/5 hover:bg-[var(--yellow)] hover:text-black text-white rounded-full transition"
            aria-label="Scroll right"
            data-testid={`${testId || "row"}-next`}
          >
            <ChevronRight size={20} />
          </button>
        </div>
      </div>

      <div className="yv-row-scroller" ref={ref}>
        {videos.map((v) => (
          <VideoCard key={`${testId}-${v.id}`} video={v} />
        ))}
      </div>
    </section>
  );
}
